module.exports = __webpack_public_path__ + "static/img/protection-04.9c03ed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/protection-04.png
// module id = 138
// module chunks = 0